import { render, staticRenderFns } from "./StockTrace.vue?vue&type=template&id=c4f7c02c&scoped=true&"
import script from "./StockTrace.vue?vue&type=script&lang=js&"
export * from "./StockTrace.vue?vue&type=script&lang=js&"
import style0 from "./StockTrace.vue?vue&type=style&index=0&id=c4f7c02c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f7c02c",
  null
  
)

export default component.exports